import { ReactNode } from "react";
import styled from "styled-components";

interface ColumnProps {
  children: ReactNode;
}

export function Column({ children }: ColumnProps) {
  return (
    <Content>
      { children }
    </Content>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(50% - 16px);

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: 100%;
  }
`;
